export const Features = [
  {
    value: "Omnichannel Messaging",
    desc: "Allow customers to communicate from any channel of their choice and respond through Pavelify multichannel messaging.",
    largeImg: "../../images/icons.jpg",
    img: "../../images/Page-1-Image-10.jpg"
  },
  {
    value: "Email Ticketing",
    desc: "Manage all customer emails from through your Pavelify ticketing system.  Assign, reassign and solve queries faster.",
    largeImg: "../../images/Page-1-Image-11.jpg",
    img: "../../images/Page-1-Image-12.jpg"
  },
  {
    value: "Analytics and Reporting",
    desc: "From live visitors, to number of leads across all lead channels. No better way to keep track of how your business is performing",
    largeImg: "../../images/Page-1-Image-13.jpg",
    img: "../../images/Page-1-Image-14.jpg"
  },
  {
    value: "Appointment Scheduling",
    desc: "Let your customers and prospects easily schedule Phone, Zoom or Google meet  calls with Pavelify appointment tool",
    largeImg: "../../images/Page-2-Image-15.jpg",
    img: "../../images/Page-2-Image-16.jpg"
  },
  {
    value: "Customer Catalogue",
    desc: "Access vital information about your customers for better sales, support  and marketing decisions.",
    largeImg: "../../images/Page-2-Image-17.jpg",
    img: "../../images/Page-3-Image-20.jpg"
  },
  {
    value: "Lead Management",
    desc: "Manage and send in app invoice to customers and prospects. Automate follow ups on unpaid deals",
    largeImg: "../../images/Page-3-Image-19.jpg",
    img: "../../images/Page-2-Image-18.jpg"
  },
  {
    value: "Help Desk Centre",
    desc: "Automate your support by offering help desk self service to your customers.  Turn your repeated questions and answers into helpful articles.",
    largeImg: "../../images/Page-3-Image-21.jpg",
    img: "../../images/Page-3-Image-22.jpg"
  },
  {
    value: "Integration",
    desc: "Easily Integrate Pavelify with your favorite apps or sync your contacts of your  favorite apps with Pavelify.",
    largeImg: "../../images/Page-3-Image-23.jpg",
    img: "../../images/Page-4-Image-24.jpg"
  }
];
